import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 80%;
    margin: 0 auto;
    padding: 20px;
    background: #f9f9f9;
    border-radius: 8px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);

    @media (max-width: 768px) {
        width: 100%;
        border-radius: 0;
    }
`;

export const TopBar = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 20px;
`;

export const StepIndicator = styled.div`
    flex: 1;
    text-align: center;
    padding: 10px 0;
    font-weight: bold;
    color: ${(props) => (props.isActive ? "#fff" : "#333")};
    background: ${(props) => (props.isActive ? "#007bff" : "#e0e0e0")};
    border-radius: 8px;
    margin: 0 5px;
`;

export const ContentWrapper = styled.div`
    width: 100%;
`;

export const FormWrapper = styled.form`
    display: flex;
    flex-direction: column;
    gap: 15px;
`;

export const Button = styled.button`
    padding: 10px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 16px;
    cursor: pointer;

    &:hover {
        background-color: #0056b3;
    }
`;

export const Heading = styled.h2`
    margin-bottom: 20px;
    text-align: center;
    color: #333;
`;

export const StepWrapper = styled.div`
    text-align: center;
`;
